import {
  createInjectionToken,
  createNoopInjectionToken,
} from 'ngxtension/create-injection-token';

export const [, provideDigitalfemsaPublicKey, DIGITALFEMSA_PUBLIC_KEY] =
  createNoopInjectionToken<string>('Digitalfemsa Public Key');

export const [injectDigitalfemsaConfig] = createInjectionToken(
  (publicKey: string) => ({
    publicKey,
    locale: 'es',
    digitalfemsaScriptUrl:
      'https://pay.digitalfemsa.io/v1.0/js/digitalfemsa-checkout.min.js',
  }),
  {
    deps: [DIGITALFEMSA_PUBLIC_KEY],
  },
);
